import React from 'react'
import { FamilyMember } from '../../../api-clients/api-types'
import { YearlyTicketRightCard } from './ticket-right-card-yearly'
import { TraineeTicketRightCard } from './ticket-right-card-trainee'
import { StationTicketRightCard } from './ticket-right-card-station'
import { FamilyMemberTicketRightCard } from './ticket-right-card-family-member'
import { TicketRightWithDraft } from '../../../types'

type TicketRightCardProps = {
  ticketRightWithDraft: TicketRightWithDraft
  familyMember?: FamilyMember
}
export const TicketRightCard: React.FC<TicketRightCardProps> = ({ ticketRightWithDraft, familyMember = null }) => {
  const { ticketRight } = ticketRightWithDraft
  const isStationTicket = ticketRight?.manualOrder?.ticketType?.canHaveStationPairs
  const isTraineeTicket = ticketRight?.manualOrder && !isStationTicket
  const isYearlyTicketRight = !isStationTicket || !isTraineeTicket

  if (ticketRight) {
    if (familyMember)
      return (
        <FamilyMemberTicketRightCard ticketRightWithDraft={ticketRightWithDraft} familyMember={familyMember} />
      )
    if (isStationTicket) return <StationTicketRightCard ticketRight={ticketRight} />
    if (isTraineeTicket) return <TraineeTicketRightCard ticketRight={ticketRight} />
    if (isYearlyTicketRight) return <YearlyTicketRightCard ticketRightWithDraft={ticketRightWithDraft} />
  }

  return <></>
}
